import { HttpService } from '@nestjs/axios'
import { Injectable } from '@nestjs/common'
import { AxiosRequestConfig } from 'axios'
import { catchError, Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable()
export class WebhookWhatsappServerService {
  constructor(private httpService: HttpService) {}

  sendSimple(data: { mensaje: string; to: string; key: string }, type: string): Observable<any> {
    const body = {
      to: data.to,
      type,
    }

    if (type === 'text') {
      body['text'] = {
        body: data.mensaje,
      }
    }
    if (type === 'image') {
      body['image'] = {
        link: data.mensaje,
        caption: '',
      }
    }
    if (type === 'document') {
      body['document'] = {
        link: data.mensaje,
        caption: '',
      }
    }
    const options: AxiosRequestConfig = {
      method: 'POST',
      headers: {
        'D360-Api-Key': data.key,
        'Content-Type': 'application/json',
      },
    }

    console.log(body, 'body')

    return this.httpService.post('https://waba.360dialog.io/v1/messages', body, options).pipe(
      map(({ data }) => {
        console.log(data)
        return data
      }),
      catchError((error) => {
        console.log(error)
        return of([error])
      }),
    )
  }

  sendTemplate(
    data: { to: string; key: string; template: string; namespace: string },
    parameters: any,
  ): Observable<any> {
    console.log('entro por template')
    const options: AxiosRequestConfig = {
      method: 'POST',
      headers: {
        'D360-Api-Key': data.key,
        'Content-Type': 'application/json',
      },
    }
    return this.httpService
      .post(
        'https://waba.360dialog.io/v1/messages',
        {
          to: data.to,
          type: 'template',
          template: {
            namespace: data.namespace,
            language: {
              policy: 'deterministic',
              code: 'es',
            },
            name: data.template,
            components: [
              {
                type: 'body',
                parameters,
              },
            ],
          },
        },
        options,
      )
      .pipe(
        map(({ data }) => {
          console.log(data, 'data del template')
          return data
        }),
        catchError((err) => {
          console.log(err, 'error')
          console.log(err?.response.data, 'data')
          console.log(err?.response?.data.meta, 'meta')
          console.log(err?.response?.data.errors, 'errors')
          return of([err])
        }),
      )
  }
}
